import script from "./handBookDownloadPage.vue?vue&type=script&setup=true&lang=js"
export * from "./handBookDownloadPage.vue?vue&type=script&setup=true&lang=js"

import "./handBookDownloadPage.vue?vue&type=style&index=0&id=5e74d511&scoped=true&lang=css"

import exportComponent from "D:\\code\\vifa官网\\vifa\\vifa-website\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5e74d511"]])

export default __exports__